import React from 'react';

import { Playerlist } from 'components';
import usePlayerList from "hooks/usePlayerList";

const SLICE = 5;

const PlayerStandings = () => {

    const { playerList, playerListLoading } = usePlayerList("current");

    const playerlistData = playerList
        .flatMap(position => position.players)
        .sort((a, b) => b.totalPoints - a.totalPoints)
        .slice(0, SLICE);

    return <Playerlist
        isLoading={playerListLoading} 
        playerData={playerlistData} 
        size='small' 
        />
}

export default PlayerStandings;